// Field-level selectors for the combo-summary container.
export const selectSiteSettings = (state) => state.common.siteSettings;
export const selectUserId = (state) => state.common.userId;
export const selectComboSummary = (state) => state.comboSummary;
export const selectIsInitialized = (state) => state.comboSummary.initialized;
export const selectDestinationContent = (state) => state.destinationContent;
export const selectError = (state) => state.error;
export const selectLabels = (state) => state.labels;
export const selectMessage = (state) => state.message;
export const selectSearchInformation = (state) => state.searchInformation;
